import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { calculatorService } from '../services/calculatorService';
import TierConfigCard from '../components/config/TierConfigCard';
import AmiByCountyCard from '../components/config/AmiByCountyCard';
import FplSmiCard from '../components/config/FplSmiCard';

import EditTierModal from '../components/config/modals/EditTierModal';
import EditAmiModal from '../components/config/modals/EditAmiModal';
import EditAmiAdderModal from '../components/config/modals/EditAmiAdderModal';
import EditFplSmiModal from '../components/config/modals/EditFplSmiModal';
import EditFplSmiAdderModal from '../components/config/modals/EditFplSmiAdderModal';

import { useEditModal } from '../components/config/hooks/useEditModal';
import { STATES } from '../constants/constants';

const CalculatorConfigPage = () => {
  const { isMasterAdmin } = useAuth();
  const [data, setData] = useState(null);

  const tierModal = useEditModal();
  const amiModal = useEditModal();
  const amiAdderModal = useEditModal();
  const fplSmiModal = useEditModal();
  const fplSmiAdderModal = useEditModal();

  useEffect(() => {
    calculatorService.getConfig().then(res => {
      if (res.success) setData(res.data);
    });
  }, []);

  if (!isMasterAdmin || !data) return null;

  const counties = Object.keys(data.amiMap || {});
  const amiRowCount =
    counties.length && data.amiMap[counties[0]]
      ? data.amiMap[counties[0]].length
      : 0;

  const getNextTier = (tiers) => {
    if (!tiers || tiers.length === 0) return 1;
    return Math.max(...tiers.map(t => t.tier)) + 1;
  }

  return (
    <>
      <TierConfigCard
        title="Washington Tiers for CARES Discounts"
        state={STATES.WA}
        tiers={data.waTiers}
        onEdit={(tier) => tierModal.openModal(tier.upcomingTier ?? tier)}
        onAdd={() => tierModal.openModal({ id: null, tier: getNextTier(data.waTiers), state: STATES.WA })}
      />

      <TierConfigCard
        title="Oregon Tiers for EDP"
        state={STATES.OR}
        tiers={data.orTiers}
        onEdit={(tier) => tierModal.openModal(tier.upcomingTier ?? tier)}
        onAdd={() => tierModal.openModal({ id: null, tier: getNextTier(data.orTiers), state: STATES.OR })}
      />

      <AmiByCountyCard
        amiMap={data.amiMap}
        amiHouseholdAdder={data.amiHouseholdAdder}
        counties={counties}
        rowCount={amiRowCount}
        onEditAmiCell={(ami) => amiModal.openModal(ami.upcomingAmi ?? ami)}
        onEditAmiAdder={(adder) =>
          amiAdderModal.openModal(adder.upcomingAdder ?? adder)
        }
      />

      <FplSmiCard
        smi={data.smi}
        fpl={data.fpl}
        fplSmiHouseholdAdder={data.fplSmiHouseholdAdder}
        onEdit={(row) => fplSmiModal.openModal(row.upcomingFplSmi ?? row)}
        onEditAdder={(adder) =>
          fplSmiAdderModal.openModal(adder.upcomingAdder ?? adder)
        }
      />

      {tierModal.open && (
        <EditTierModal
          tier={tierModal.entity}
          onClose={tierModal.closeModal}
          onSave={setData}
        />
      )}

      {amiModal.open && (
        <EditAmiModal
          ami={amiModal.entity}
          onClose={amiModal.closeModal}
          onSave={setData}
        />
      )}

      {amiAdderModal.open && (
        <EditAmiAdderModal
          amiAdder={amiAdderModal.entity}
          onClose={amiAdderModal.closeModal}
          onSave={setData}
        />
      )}

      {fplSmiModal.open && (
        <EditFplSmiModal
          fplSmi={fplSmiModal.entity}
          onClose={fplSmiModal.closeModal}
          onSave={setData}
        />
      )}

      {fplSmiAdderModal.open && (
        <EditFplSmiAdderModal
          fplSmiAdder={fplSmiAdderModal.entity}
          onClose={fplSmiAdderModal.closeModal}
          onSave={setData}
        />
      )}
    </>
  );
};

export default CalculatorConfigPage;